import { Spinner } from 'react-bootstrap';

function ViewSpinner() {
  return (
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
}

export default ViewSpinner;